import { render } from "./BlockTiles.vue?vue&type=template&id=5027aeb6&scoped=true"
import script from "./BlockTiles.vue?vue&type=script&lang=js"
export * from "./BlockTiles.vue?vue&type=script&lang=js"

import "./BlockTiles.vue?vue&type=style&index=0&id=5027aeb6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aryav\\Desktop\\Don't touch this file\\Talreq\\talreq\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5027aeb6"]])

export default __exports__